export enum DeliveryType {
  Entrega_na_empresa = 'PICKUP',
  Entrega_na_empresa_ou_Porta_a_porta = 'PICKUP_OR_DOOR_TO_DOOR',
  Porta_a_porta = 'DOOR_TO_DOOR',
}